/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Pregnancy_Nutrition_TermsInputs */

const en_service_type_pregnancy_nutrition_terms = /** @type {(inputs: Service_Type_Pregnancy_Nutrition_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pregnancy, breastfeeding, fertility, prenatal diet`)
};

const pl_service_type_pregnancy_nutrition_terms = /** @type {(inputs: Service_Type_Pregnancy_Nutrition_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ciąża, karmienie piersią, dieta ciężarnej, płodność`)
};

/**
* | output |
* | --- |
* | "pregnancy, breastfeeding, fertility, prenatal diet" |
*
* @param {Service_Type_Pregnancy_Nutrition_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_pregnancy_nutrition_terms = /** @type {((inputs?: Service_Type_Pregnancy_Nutrition_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Pregnancy_Nutrition_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_pregnancy_nutrition_terms(inputs)
	return en_service_type_pregnancy_nutrition_terms(inputs)
});